// @ts-nocheck
import React from "react";
import { compose } from "modules/core";
import { withApollo } from '@apollo/client/react/hoc';
import TreeEditView from "modules/poc-dashboard/components/organization/TreeEditView";
import { ORGANIZATION_EMPLOYEE, VERTICAL_DETAIL_TREE, VERTICAL_EMPLOYEE } from "modules/poc-dashboard/graphql/organizationQuery.gql";
import { gql, useMutation } from "@apollo/react-hooks";
import { Capitalize, getIntFromString } from "modules/look";
import { message } from "antd";
import { getOrgID } from "./organizationOperations";
const EditVerticalContainer = (props) => {
    const { client, selected_node, UpdateNode, onClose, orgToFetchData } = props
    const [detail, setDetail] = React.useState()
    const [managers_list, setManagerList] = React.useState([])
    const [selected_employee_list, setSelectedEmployeeList] = React.useState([])
    const [all_employee_list, SetAllEmployeeList] = React.useState([])
    const [api_loading, setApiLoading] = React.useState(true)
    const [saveChanges, SetSaveChanges] = React.useState()
    const selected_employee_ref = React.useRef([])

    React.useEffect(() => {
        if (selected_employee_list?.length) {
            selected_employee_ref.current = selected_employee_list
        }
    }, [selected_employee_list])

    React.useEffect(() => {
        if (selected_node) {
            verticalDetail({ id: selected_node?.node_id })
            if (selected_node?.node_type === "VERTICAL") {
                getAllOrganizationEmployee()
            } else if (selected_node?.node_type === "SUB-VERTICAL") {
                getAllVerticalEmployee({ vertical: getIntFromString(selected_node?.node?.parent_node) })
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected_node])



    const UPDATE_VERTICAL = gql`
    mutation updateVerticalData {
        ${saveChanges ?
            `updateVertical(id:${getIntFromString(selected_node?.node_id)},name:"${saveChanges?.name}",heads:[${saveChanges?.managers_list?.map(i => getIntFromString(i?.id))}]){
                vertical{
                    id
                }
            }
            
            ${saveChanges?.selected_employee_list?.filter(i => !i.member_id && !i?.member_deleted)?.map((i, index) =>
                `create${index}:createMember(memberData:{
                        employeeId:"${i?.id}",
                        reportingLine: "solid",
                        memberFrom:{
                        verticalId:"${selected_node?.node_id}"
                        }
                    }){
                        member{
                            id
                        }    
                    }
                    `
            ).join('')
            }
             ${saveChanges?.selected_employee_list?.filter(i => i.member_id && i?.member_deleted)?.map((i, index) =>
                `delete${index}:deleteMember(id:"${i.member_id}"){
                        member{
                            id
                        }
                    }
                    `
            ).join('')
            }
            `
            : null
        }
    }
    `;

    // eslint-disable-next-line no-unused-vars
    const [updateDefinition, { data, error }] = useMutation(UPDATE_VERTICAL);

    React.useEffect(() => {
        if (saveChanges) {
            update()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveChanges])

    const update = async () => {
        setApiLoading(true)
        try {
            const response = await updateDefinition()

            if (response?.data) {
                message.success('Changes saved successfully');
                let node = selected_node?.node
                node["name"] = saveChanges?.name
                node.attribute.detail.label = saveChanges?.name
                node.attribute["employee"] = saveChanges?.selected_employee_list?.filter(i => !i?.member_deleted)?.length
                node.attribute["manager"] = saveChanges?.managers_list?.map((i => {
                    return {
                        email: i?.user?.email,
                        empolee_id: i?.id,
                        name: `${Capitalize(i?.user?.firstName)} ${Capitalize(i?.user?.lastName) || ""}`,
                        profile_image: i?.user?.profile?.profileImage,
                        role: "VERTICAL HEAD"
                    }
                }))

                setApiLoading(false)
                UpdateNode(node)
            } else {
                setApiLoading(false)
            }
        } catch (error) {
            message.error('Failed to save changes')
            console.error("EditVerticalContainer -> update", error)
            onClose()
        }
    }

    const getAllOrganizationEmployee = async (filter) => {
        const { data } = await client.query({
            query: ORGANIZATION_EMPLOYEE,
            variables: { ...filter, id: getOrgID(props) || orgToFetchData?.id },
            fetchPolicy: 'network-only'
        });
        if (data?.organizationById?.employees) {
            let employees = data?.organizationById?.employees?.edges?.map(({ node }) => node)?.sort((a, b) => a?.user?.firstName?.toLowerCase().localeCompare(b?.user?.firstName?.toLowerCase()))
            SetAllEmployeeList(employees)
        }
    }

    const getAllVerticalEmployee = async (filter) => {
        const { data } = await client.query({
            query: VERTICAL_EMPLOYEE,
            variables: {
                ...filter,
                id: getOrgID(props) || orgToFetchData?.id
            },
            fetchPolicy: 'network-only'
        });
        if (data?.organizationById?.verticalSet?.edges?.[0]?.node) {
            let heads = data?.organizationById?.verticalSet?.edges?.[0]?.node?.heads?.edges?.map(({ node }) => node)
            let employees = data?.organizationById?.verticalSet?.edges?.[0]?.node?.employees?.edges?.map(({ node }) => node)
            let list = [...heads, ...employees]
            var setObj = new Set();
            list = list.reduce((acc, item) => {
                if (!setObj.has(item?.user?.id)) {
                    setObj.add(item?.user?.id)
                    acc.push(item)
                }
                return acc;
            }, [])
            list = list?.sort((a, b) => a?.user?.firstName?.toLowerCase().localeCompare(b?.user?.firstName?.toLowerCase()))
            SetAllEmployeeList(list)
        }
    }

    const verticalDetail = async (filter) => {
        try {
            const { data } = await client.query({
                query: VERTICAL_DETAIL_TREE,
                variables: {
                    ...filter,
                    orgId: getOrgID(props) || orgToFetchData?.id,
                    verticalFloat: getIntFromString(filter?.id),
                    verticalString: filter?.id
                },
                fetchPolicy: 'network-only'
            });
            if (data?.organizationById?.verticalSet?.edges?.[0]?.node) {
                let detail = {
                    id: data?.organizationById?.verticalSet?.edges?.[0]?.node?.id,
                    name: data?.organizationById?.verticalSet?.edges?.[0]?.node?.name
                }
                setDetail(detail)
                let managers = data?.organizationById?.verticalSet?.edges?.[0]?.node?.heads?.edges?.map(({ node }) => node)
                setManagerList(managers)
                let selected_employee = data?.organizationById?.verticalSet?.edges?.[0]?.node?.employees?.edges?.map(({ node }) => { return { ...node, member_id: node?.memberSet?.edges?.length ? node?.memberSet?.edges[0]?.node?.id : null } })
                selected_employee_ref.current = selected_employee_ref.current?.concat(selected_employee)
                setSelectedEmployeeList(selected_employee_ref.current)
                if (data?.organizationById?.verticalSet?.edges?.[0]?.node?.employees?.pageInfo?.hasNextPage) {
                    verticalDetail({ id: filter?.id, after: data?.organizationById?.verticalSet?.edges?.[0]?.node?.employees?.pageInfo?.endCursor })
                }
                setApiLoading(false)
            }
        } catch (error) {
            console.error("EditVerticalContainer -> update", error)
        }
    }

    let search_debounce = React.useRef()
    const onSearchEmployee = (search) => {
        if (search_debounce?.current) {
            clearTimeout(search_debounce?.current)
        }
        search_debounce.current = setTimeout(() => {
            immediateSearchFeature(search)
        }, 1000);
    }

    const immediateSearchFeature = (search) => {
        if (search_debounce?.current) {
            clearTimeout(search_debounce?.current)
        }
        if (selected_node?.node_type === "VERTICAL") {
            getAllOrganizationEmployee({ user_FirstName: search })
        }
        else if (selected_node?.node_type === "SUB-VERTICAL") {
            getAllVerticalEmployee({ vertical: getIntFromString(selected_node?.node?.parent_node), user_FirstName: search })
        }
    }

    return (
        <>
            <TreeEditView {...props} onSearchEmployee={onSearchEmployee} immediateSearchFeature={immediateSearchFeature} edit_view={selected_node?.node_type} api_loading={api_loading} setSelectedEmployeeList={setSelectedEmployeeList} setManagerList={setManagerList} detail={detail} managers_list={managers_list} selected_employee_list={selected_employee_list} all_employee_list={all_employee_list} SetSaveChanges={SetSaveChanges} />
        </>
    )
}


export default compose(withApollo)(EditVerticalContainer);